var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useState } from "react";
import { activitiesService } from "../../../../services";
import fileDownload from "js-file-download";
import { Button } from "@material-ui/core";
import { GetApp } from "@material-ui/icons";
export const DocumentDownloadAttachment = ({ caseId, id, attachmentId, label, }) => {
    const [state, setState] = useState("NOT_DOWNLOADED");
    const onClick = () => __awaiter(void 0, void 0, void 0, function* () {
        setState("DOWNLOADING");
        const blob = yield activitiesService.downloadDocumentAttachment(caseId, id, attachmentId);
        fileDownload(blob, label);
        setState("DOWNLOADED");
    });
    return (React.createElement(Button, { variant: "outlined", color: "secondary", onClick: () => onClick(), "data-test": "activity-document-download" },
        React.createElement(GetApp, null),
        state === "NOT_DOWNLOADED" ? "Download: " : "",
        state === "DOWNLOADING" ? "Downloading: " : "",
        state === "DOWNLOADED" ? "Downloaded: " : "",
        label));
};
